<div [formGroup]="dataForm">
  <label for="autocompleteField" class="visually-hidden">Autocomplete Field</label>
  <input id="autocompleteField" #autoCompleteInputRef type="text" class="form-control" [id]="id" formControlName="selection" [matAutocomplete]="auto" (change)="changeMyControl($event.target.value)">
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" class="autocomplete">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option.Name" (click)="stopPrefillonSelect()" onkeypress="stopPrefillonSelect()">
      {{option.value}}
    </mat-option>
  </mat-autocomplete>
</div>